<script setup>
import ArticleCard from '@components/global/article-card.vue'

defineProps(['item'])
</script>
<template>
	<section class="container text-center">
		<span class="h9">blog</span>
		<h1>Discover what's new</h1>
	</section>

	<section class="container">
		<ArticleCard :item="item" class="w-full" type="hero" />
	</section>
</template>
